











import { Component, Vue } from "vue-property-decorator";

@Component({
  name: 'ResetPassword'
})
export default class ResetPassword extends Vue {
  public token: string;
}
